import PropTypes from 'prop-types';
import React from 'react';
import {withSiteSettings} from '../../containers/DataContainer/siteSettings/withSiteSettings';
import {withTrackFont} from '../../containers/DataContainer/siteSettings/withTrackFont';
import {withoutSize} from '../../services/env/siteSettings/fonts/fonts';
import {Animation} from '../ui/Animation';
import {FADE_IN_UP} from '../ui/TransitionsBehavior/FadeInUp';
import styles from './CoverTitles.scss';

const ArtistTitle = ({trackFont, children}) => {
  const artistStyle = withoutSize(trackFont);
  return (
    <h4 className={styles.artistTitle} style={artistStyle} title={children} data-hook="artist-title-header">
      {children}
    </h4>
  );
};

ArtistTitle.propTypes = {
  trackFont: PropTypes.object,
  children: PropTypes.string,
};

const ArtistTitleComponent = withTrackFont(ArtistTitle);

const EntityTitle = ({siteSettings, children}) => {
  const entityStyle = withoutSize(siteSettings.fonts.title);
  return (
    <h3 className={styles.entityTitle} style={entityStyle} title={children} data-hook="entity-title-header">
      {children}
    </h3>
  );
};

EntityTitle.propTypes = {
  siteSettings: PropTypes.object,
  children: PropTypes.string,
};

const EntityTitleComponent = withSiteSettings(EntityTitle);

export const CoverTitles = ({artistName, entityName, className}) => {
  return (
    <div className={className} data-hook="cover-titles">
      <Animation motions={FADE_IN_UP} animationKey="cover-titles-transition">
        <div>
          <EntityTitleComponent>{entityName}</EntityTitleComponent>
          <ArtistTitleComponent>{artistName}</ArtistTitleComponent>
        </div>
      </Animation>
    </div>
  );
};

CoverTitles.propTypes = {
  entityName: PropTypes.string.isRequired,
  artistName: PropTypes.string.isRequired,
  className: PropTypes.string,
};
